/* esm.sh - lib0@0.2.117/symbol */
var t=Symbol,e=o=>typeof o=="symbol";export{t as create,e as isSymbol};
//# sourceMappingURL=symbol.mjs.map